import { z } from 'zod';
/** Stable, machine-readable error codes returned in the `code` field of problem details. */
export const ERROR_CODES = [
    'internal_error',
    'not_found',
    'validation_failed',
    'bad_request',
    'unauthorized',
    'forbidden',
    'conflict',
    'rate_limited',
    'service_unavailable',
    'auth.invalid_credentials',
    'auth.account_deactivated',
    'auth.invalid_token',
    'auth.refresh_reused',
    'auth.registration_disabled',
    'auth.email_taken',
    'auth.already_in_family',
    'auth.origin_not_allowed',
    'auth.owner_must_transfer',
    'auth.family_name_mismatch',
    'family.currency_locked',
    'account.not_found',
    'account.forbidden',
    'account.private_not_allowed',
    'account.balance_not_zero',
    'account.archived',
    'category.not_found',
    'category.name_taken',
    'invitation.not_found',
    'invitation.expired',
    'invitation.already_used',
    'invitation.revoked',
    'invitation.member_has_login',
    'member.not_found',
    'member.forbidden_change',
    'idempotency.key_invalid',
    'idempotency.key_reused',
    'idempotency.in_progress',
];
/** RFC 9457 problem details body (`application/problem+json`). */
export const problemDetailsSchema = z.object({
    type: z.string(),
    title: z.string(),
    status: z.number().int(),
    code: z.string(),
    detail: z.string().optional(),
    instance: z.string().optional(),
    requestId: z.string().optional(),
    errors: z
        .array(z.object({
        path: z.string(),
        message: z.string(),
    }))
        .optional(),
});
//# sourceMappingURL=problem.js.map